"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParentContent = exports.getParentPath = exports.getGeoPointValues = exports.getNumberValues = exports.getStringValues = exports.isResponseContent = void 0;
var lodash_1 = require("lodash");
var geopoint_1 = require("./geopoint");
function isResponseContent(v) {
    return v instanceof Object && !Array.isArray(v);
}
exports.isResponseContent = isResponseContent;
function handleStarPath(v, path, consumer) {
    if (path.startsWith(".")) {
        path = path.substring(1);
    }
    var starIndex = path.indexOf("[*]");
    if (starIndex > 0) {
        var node = lodash_1.get(v, path.substring(0, starIndex));
        if (node) {
            if (!Array.isArray(node)) {
                throw Error("Expected an array since [*] was given in path");
            }
            for (var _i = 0, node_1 = node; _i < node_1.length; _i++) {
                var child = node_1[_i];
                if (!isResponseContent(child)) {
                    throw Error("Expected an object given path");
                }
                handleStarPath(child, path.substring(starIndex + 3), consumer);
            }
        }
    }
    else if (path === "") {
        consumer(v);
    }
    else {
        consumer(lodash_1.get(v, path));
    }
}
function getValues(v, path, typeChecker, parser) {
    var nodes = [];
    handleStarPath(v, path, function (c) {
        if (typeChecker(c)) {
            nodes.push(parser(c));
        }
        else if (Array.isArray(c)) {
            for (var _i = 0, c_1 = c; _i < c_1.length; _i++) {
                var child = c_1[_i];
                if (typeChecker(child)) {
                    nodes.push(parser(child));
                }
                else {
                    nodes.push(null);
                }
            }
        }
        else {
            nodes.push(null);
        }
    });
    return nodes;
}
function getValuesWithAlternates(v, path, typeChecker, parser, alternates) {
    if (alternates === void 0) { alternates = []; }
    var values = getValues(v, path, typeChecker, parser);
    if (!values.some(function (v) { return v === undefined || v === null; })) {
        return values;
    }
    var alternateValueSets = [];
    for (var _i = 0, alternates_1 = alternates; _i < alternates_1.length; _i++) {
        var alternate = alternates_1[_i];
        if (path.includes(alternate.targetField)) {
            alternateValueSets.push(getValues(v, path.replace(alternate.targetField, alternate.alternateField), typeChecker, parser));
        }
    }
    for (var _a = 0, alternateValueSets_1 = alternateValueSets; _a < alternateValueSets_1.length; _a++) {
        var valueSet = alternateValueSets_1[_a];
        if (valueSet.length === values.length) {
            for (var i = 0; i < values.length; i++) {
                if (values[i] === undefined || values[i] === null) {
                    values[i] = valueSet[i];
                }
            }
        }
    }
    return values;
}
var isParsableAsString = function (v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean";
};
var parseString = function (v) { return (v === "" ? null : String(v)); };
function getStringValues(v, path, alternates) {
    if (alternates === void 0) { alternates = []; }
    return getValuesWithAlternates(v, path, isParsableAsString, parseString, alternates);
}
exports.getStringValues = getStringValues;
var isParsableAsNumber = function (v) { return !isNaN(Number(v)); };
function getNumberValues(v, path, alternates) {
    if (alternates === void 0) { alternates = []; }
    return getValuesWithAlternates(v, path, isParsableAsNumber, Number, alternates);
}
exports.getNumberValues = getNumberValues;
function getGeoPointValues(v, path, alternates) {
    if (alternates === void 0) { alternates = []; }
    return getValuesWithAlternates(v, path, geopoint_1.isParsableAsGeoPoint, geopoint_1.parseGeoPoint, alternates);
}
exports.getGeoPointValues = getGeoPointValues;
function getParentPath(path) {
    var lastDot = path.lastIndexOf(".");
    var lastBracket = path.lastIndexOf("[*]");
    return path.substring(0, Math.max(lastDot, lastBracket));
}
exports.getParentPath = getParentPath;
function getParentContent(v, path, alternates) {
    if (alternates === void 0) { alternates = []; }
    path = getParentPath(path);
    return getValuesWithAlternates(v, path, isResponseContent, function (v) { return v; }, alternates);
}
exports.getParentContent = getParentContent;
//# sourceMappingURL=content.js.map